import { Avatar, Flex, Text, Box, Stack, Tooltip } from '@mantine/core';
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext';
import { useContext } from 'react';
import { LIGHT_BLUE_BACKGROUND, LIGHT_BLUE_CELL, ORGS_RELATED_TO_IDEA_BACKGROUND, PRIMARY_BLUE } from '../../../../constants/colors';
import OwnerHoverCard from './OwnerHoverCard';
import { formatBigMonetaryValue, getNestedValue } from '../../../ideaNiv/Funcs';
import SyncContext from '../../../../context/SyncContext';
import { getNestedFieldValue } from '../../../ideaNiv/helpers/calculateImpactResults';
import { OwnerAvatar } from './OwnerAvatar';

interface MultipleCellProps {
  record: any;
  accessor: string;
  statuses: any[];
  isMatchingStatus: boolean;
}

export const MultipleCell = ({ record,
  accessor,
  statuses,
  isMatchingStatus
}: MultipleCellProps) => {
  
  const { customers, openActivity, impactAggregationProperties } = useContext(SingleCustomerContext);
  

  const mainImpactProperty = impactAggregationProperties?.find((property: any) => property?.impact?.isMainImpact)
  const fieldPath = mainImpactProperty?.fieldPath
  const mainImpactLabel = mainImpactProperty?.label
  const evidences = record?.evidences
  const totalMainImpact = evidences?.reduce((sum: number, evidence: any) => sum + (getNestedFieldValue(evidence, fieldPath) || 0), 0)
  const ideaOrgids = evidences?.map((evidence: any) => evidence?.orgId)
  const orgsRelatedToIdea = customers?.filter((customer: any) => ideaOrgids?.includes(customer?._id))
  const orgsRelatedToIdeaCount = orgsRelatedToIdea?.length

 
  return (
    <Flex align="center" justify="center">
      {
        isMatchingStatus ? (
          <Flex
            w={122}
            h={24}
            p={4}
            sx={{
              borderRadius: 30,
              backgroundColor: LIGHT_BLUE_CELL,
            }}
            align="center"
            justify="space-between"
          >
            <Box
              sx={{
                width: 20,
                height: 18,
                borderRadius: '50%',
                backgroundColor: ORGS_RELATED_TO_IDEA_BACKGROUND,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: 8,
              }}
            >
              <Tooltip label='Customers' withinPortal>
                <Text size="sm" weight={500} color='white' >
                  {orgsRelatedToIdeaCount}
                </Text>
              </Tooltip>
            </Box>
            <Box maw={60}>
              <Tooltip label={mainImpactLabel} withinPortal>
                <Text size="sm" weight={500} color={PRIMARY_BLUE}>
                  {formatBigMonetaryValue(totalMainImpact)}
                </Text>
              </Tooltip>
            </Box>

            <Box>
              <Stack justify='center' onClick={openActivity}>
                <OwnerAvatar data={record} />
              </Stack>
            </Box>
            
          </Flex>
        ) : (
          <></>
        )
      }
    </Flex>
  );
};